// Story 8.10 (ADO-2019), Q3: "Not added · N lines" under the after-accept panel (the 8.10 Figma
// exports, "Q3 · Added, some lines not added"): one card per line that was going to be added
// and was not, and that the review had not already shown as not added (`hhtNotAddedCards`).
// Each card is the product, a red pill with the reason, "code · depot · N cases" and the
// reason in words. Nothing renders when there is no such line.
import { casesLabel } from '../../basket/cartTotals';
import { HhtPill } from './HhtPill';
import { linesLabel } from './hhtFormat';
import type { HhtNotAddedCard } from './hhtNotAdded';
import styles from './HhtOrders.module.css';

export function HhtNotAddedList({ cards }: { readonly cards: readonly HhtNotAddedCard[] }) {
  if (cards.length === 0) return null;
  return (
    <section className={styles.section} aria-labelledby="hht-not-added-title">
      <div className={styles.sectionTitleRow}>
        <h2 id="hht-not-added-title" className={styles.sectionTitle}>
          Not added
        </h2>
        <HhtPill tone="errorCount">{linesLabel(cards.length)}</HhtPill>
      </div>
      <ul className={styles.list}>
        {cards.map(({ line, pill, detail }) => {
          const name = line.productName ?? line.skuCode;
          const meta = [line.skuCode, line.depotName, casesLabel(line.quantity)]
            .filter((part): part is string => part !== null && part !== '')
            .join(' · ');
          return (
            <li
              key={line.skuCode}
              className={`${styles.panel} ${styles.attentionCard}`}
              aria-label={name}
            >
              <p className={styles.attentionName}>
                <span>{name}</span>
                <HhtPill tone="error" dot>
                  {pill}
                </HhtPill>
              </p>
              <p className={styles.attentionMeta}>{meta}</p>
              <p className={styles.attentionDetail}>{detail}</p>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
